import { render, staticRenderFns } from "./MTable.vue?vue&type=template&id=27d5d069&"
import script from "./MTable.vue?vue&type=script&lang=js&"
export * from "./MTable.vue?vue&type=script&lang=js&"
import style0 from "./MTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports